/**
 * Locale preference persistence.
 *
 * When a visitor switches language we remember the choice in a first-party
 * cookie so SSR can honour it on the next request. The toggle itself always
 * navigates to the equivalent URL, which is the real source of truth for the
 * active locale - this cookie just lets the root redirect a bare `/` visit to a
 * returning visitor's preferred locale (read server-side via
 * {@link readLocaleFromCookieHeader}).
 */
import { isLocale } from './config'
import type { Locale } from './config'
import { setCookie } from '../cookies'

export const LOCALE_COOKIE = 'ae_locale'
const COOKIE_DAYS = 365

export function persistLocale(locale: Locale): void {
  setCookie(LOCALE_COOKIE, locale, COOKIE_DAYS)
}

/** Parse a `Cookie` header value for the persisted locale (server-side). */
export function readLocaleFromCookieHeader(
  cookieHeader: string | null | undefined,
): Locale | null {
  if (!cookieHeader) return null
  const match = cookieHeader.match(
    new RegExp(`(?:^|; )${LOCALE_COOKIE}=([^;]+)`, 'u'),
  )
  const value = match ? decodeURIComponent(match[1]) : null
  return isLocale(value) ? value : null
}
